import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard, copy, list"><path fillRule="evenodd" clipRule="evenodd" d="M8 3.75C8 2.7835 8.7835 2 9.75 2H14.25C15.2165 2 16 2.7835 16 3.75V4H18.25C19.2165 4 20 4.7835 20 5.75V20.25C20 21.2165 19.2165 22 18.25 22H5.75C4.7835 22 4 21.2165 4 20.25V5.75C4 4.7835 4.7835 4 5.75 4H8V3.75ZM9.5 6.25C9.5 6.38807 9.61193 6.5 9.75 6.5H14.25C14.3881 6.5 14.5 6.38807 14.5 6.25V3.75C14.5 3.61193 14.3881 3.5 14.25 3.5H9.75C9.61193 3.5 9.5 3.61193 9.5 3.75V6.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClipboard;
